import useDelayedQuery from '@hooks/useDelayedQuery.js';
import { isTestMode } from '@util/const.js';
import { fakeTiltifyCampaign } from '@data/example/index.js';
import { tiltify } from '@playlive/tiltify-lib';

const useTiltifyCampaign = ({
  campaignID,
  userSlug,
  campaignSlug,
  isTeam = false,
  enabled = true,
}) => {
  const { data: campaign, isFetching: campaignLoading } = useDelayedQuery({
    queryKey: ['tiltify', 'getCampaign', campaignID],
    placeholderData: null,
    queryFn: async () => {
      if (isTestMode) {
        return [fakeTiltifyCampaign];
      }

      if (
        (!campaignID || campaignID === 'null') &&
        (!userSlug || userSlug === 'null') &&
        (!campaignSlug || campaignSlug === 'null')
      )
        return null;
      tiltify.UseProxy();

      if (campaignID && campaignID !== 'null')
        return await tiltify.GetCampaign(campaignID, isTeam);
      else if (userSlug && campaignSlug) {
        return await tiltify.FindCampaign(userSlug, campaignSlug, isTeam);
      }
    },
    enabled,
    refetchInterval: 60000, // Refetch every minute
  });

  return { campaign, campaignLoading };
};

export default useTiltifyCampaign;
